import { Statistics, StatisticsLogService } from '@/store/modules/StatisticsLog'

export const getCookieValue = (name: string): string => Array.from(document.cookie.split(';')).filter((c: string) => c.trim().startsWith(`${name}=`)).map((c: string) => c.split('=')[1])[0]

// eslint-disable-next-line
const AWS = require('aws-sdk')
AWS.config.region = 'ap-northeast-1'
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: process.env.VUE_APP_IDENTITY,
})

const kinesis = new AWS.Kinesis({
  apiVersion: '2013-12-02'
})

/**
 * シングルトンパターンで作成
 */
class ClientTracker {
  public uid = ''
  public ipaddress = ''
  public userAgent = ''
  public logs: Statistics[] = []

  private async putLogs (logs: Statistics[]): Promise<void> {
    // upload data to Amazon Kinesis
    const Records = Array.from(logs).map((log) => ({
      Data: JSON.stringify({
        ...log
      }),
      PartitionKey: '1'
    }))

    kinesis.putRecords({
      Records,
      StreamName: process.env.VUE_APP_STATISTICS_LOGS_STREAMS_NAME
    }, async function (err: any, data: any) {
      console.log(data)
      if (err || data.FailedRecordCount > 0) {
        console.error(data, err)
      } else {
        const lastIndex = Array.from(logs).sort((a, b) => ((b.id as number) - (a.id as number)))[0].id as number
        await StatisticsLogService.clean(lastIndex)
      }
    })
  }

  constructor () {
    this.uid = getCookieValue('uid')
    this.ipaddress = getCookieValue('fromIpAddress')
    this.userAgent = navigator.userAgent

    const kinesis = new AWS.Kinesis({
      apiVersion: '2013-12-02'
    })

    // upload data to Amazon Kinesis every second if data exists
    setInterval(async () => {
      const logs = await StatisticsLogService.findAll()

      if (logs.length) {
        // upload data to Amazon Kinesis
        await this.putLogs(logs)
      } else {
        console.log('No logs to send ...')
      }
    }, 5000)

    // Send a log when leaving the page
    window.addEventListener('beforeunload', async () => {
      let logs: Statistics[] = await StatisticsLogService.findAll()

      while (logs.length) {
        // upload data to Amazon Kinesis
        await this.putLogs(logs)

        logs = await StatisticsLogService.findAll()
      }
    })
  }

  push (params: any) {
    const log: Statistics = {
      type: params.key,
      uid: this.uid,
      ipaddress: this.ipaddress,
      referrer: document.referrer,
      userAgent: this.userAgent,
      meta: params,
      timestamp: Date.now(),
    }
    if (process.env.VUE_APP_ENV !== 'local') {
      StatisticsLogService.add(log)
    }
  }
}

const tracker = new ClientTracker()
export default tracker
